export const DEFAULT_AUDIO_THUMBNAIL =
  'https://media-api.xogrp.com/images/b58e8a12-a2d1-4602-9794-53c6cbf0b0d8';
export const AWS_S3_MEDIA_HOST = 'AWS S3';
export const YOUTUBE_MEDIA_HOST = 'Youtube';
export const VIMEO_MEDIA_HOST = 'Vimeo';
